import { render, staticRenderFns } from "./LabelEstado.vue?vue&type=template&id=3a4ad6b6&"
import script from "./LabelEstado.vue?vue&type=script&lang=js&"
export * from "./LabelEstado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports